export const ACHIEVEMENT_NOTIFICATION_MAX_VISIBLE_COUNT = 10;

export const ACHIEVEMENT_NOTIFICATION_TOAST_GROUP = "achievement";
